{
  "overridesEnabledBadgeLabel": "Invalida en"
}
